export default __webpack_public_path__ + "static/media/Reload.23fb6ee2.svg";